import React, { ErrorInfo, ReactNode } from "react";
import weappMonitorInstance from '../monitor';
import dayjs from '../dayjs';
import { ua } from "../ua";
import { getLabel } from "../locale";

const WeappChunkLoadErrorHandleTimestamp = 'WeappChunkLoadErrorHandleTimestamp';

const isChunkLoadFailed = (errMsg: string) => errMsg && (
  errMsg.indexOf('ChunkLoadError: Loading chunk') !== -1
  || errMsg.indexOf('TypeError: Cannot read property \'call\' of undefined') !== -1
);

export const chunkLoadErrorHandler = (errMsg: string) => {
  if (isChunkLoadFailed(errMsg)) {
    const today = dayjs().format('YYYYMMDD');
    const timestamp: string = window.localStorage?.getItem?.(WeappChunkLoadErrorHandleTimestamp) || '';
    // 如果今天已经刷新过则今天不再处理该异常
    if (!timestamp || dayjs(timestamp).isBefore(dayjs(today))) {
      // 如果 chunk 加载失败，则刷新页面
      if (ua.device === 'PC' && window.weappUi?.Dialog?.confirm) {
        window.weappUi.Dialog.confirm({
          mask: true,
          content: getLabel('184773','当前系统加载资源异常，确定要刷新页面吗？'),
          onOk: () => {
            window.location.reload();
          }
        });
      } else if (ua.device !== 'pc' && window.weappUi?.MDialog?.prompt) {
        window.weappUi.MDialog.prompt({
          mask: true,
          message: getLabel('184773','当前系统加载资源异常，确定要刷新页面吗？'),
          prompt: false,
          onOk: () => {
            window.location.reload();
          }
        });
      }
      window.localStorage?.setItem?.(WeappChunkLoadErrorHandleTimestamp, today);
    }
  }
}

export interface ErrorBoundaryProps {
  fallback?: ReactNode | (() => ReactNode);
  onError?: (error: Error, info: ErrorInfo, props?: any) => void;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, any> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Display fallback UI
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    const { onError } = this.props;
    // You can also log the error to an error reporting service
    // props
    let props;
    if (React.isValidElement(this.props.children)) {
      // 获取子节点的 props
      props = this.props.children.props;
    }
    onError?.(error, info, props) || console?.error?.(error, info, props);
    // console?.error?.('--monitor-jsError--', error, info);
    
    // 增加错误上报处理
    const name = error.name;
    const message = error.message;
    let msg = '';
    if (name) {
      msg += `${error.name}: `;
    }
    if (message) {
      msg += message;
    }
    weappMonitorInstance.addTask('error', {
      type: 'js',
      message: msg,
      stack: error.stack || '',
    })
    onError?.(error, info) || console?.error?.(error, info);
    // 处理模块加载异常
    chunkLoadErrorHandler(String(error));
  }

  render() {
    const { fallback } = this.props;
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return typeof fallback === 'function' ? fallback() : fallback || null;
    }
    return this.props.children;
  }
}
